import { History, LocationDescriptor } from 'history';
import { IMAGE_LIST_PATH } from 'components/ui/LargeImageGallery';

export type ImageHistory =
  | {
      fromBusiness?: boolean;
      fromImages?: boolean;
    }
  | undefined;

// A test seam allowing for spying on component use of the history APIs.
// Import this only from LargeImageGallery, ImageListRoute, or from
// test code!
export const HistorySeam = {
  push: (
    history: History<ImageHistory>,
    location: LocationDescriptor<ImageHistory>,
    state?: ImageHistory
  ) => history.push(location, state),
  replace: (
    history: History<ImageHistory>,
    location: LocationDescriptor<ImageHistory>,
    state?: ImageHistory
  ) => history.replace(location, state),
  goBack: (history: History<ImageHistory>) => history.goBack(),
};

/**
 * Get the appropriate base URL (e.g., business page, offering / events page, etc. based on match params)
 */
export function getRootImageFlowPagePath(url: string) {
  return url.substring(0, url.indexOf(IMAGE_LIST_PATH));
}
